import { DialogActions } from '@mui/material';
// import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import useTheme from '@mui/material/styles/useTheme';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {
  applyAsVolunteer,
  submitVolunteeringEffort,
} from '../../stores/postActions';
import useStore from '../../stores/store';
import ActivitySuccess from '../ActivitySuccess';
import Popup from '../Dialogs/Popup';
import StyledContainedButton from '../Styled/StyledContainedButton';
import VolunteeringApplicationForm from './volunteeringApplicationForm';
import VolunteeringDetails from './volunteeringDetails';
import VolunteeringEffortForm from './VolunteeringEffortForm';
import VolunteeringOpportunityModel from './volunteeringOpportunityModel';
import Dialog from '@ui/Dialog';
import Typography from '@ui/Typography';
import ActivitySuccessDialog from '../ActivitySuccessDialog';
import useUserProfile from '@/hooks/useUserProfile';
import { useUpdateUserVolunteeringStatus } from '@/actions/feed.actions';

const DialogSteps = {
  details: 'details',
  application: 'application',
  success: 'success',
  logEffort: 'logEffort',
};

function VolunteeringDetailsDialog(props) {
  const { open, opportunity = null, onClose, nonProfit, post } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [step, setStep] = useState(DialogSteps.details);
  const [rewardEarned, setRewardEarned] = useState(0);
  const [successType, setSuccessType] = useState();
  const profile = useUserProfile();

  const userVolunteeringStatus =
    (opportunity && opportunity?.userVolunteeringInfo?.status) || 'none';

  const { mutate: updateUserVolunteeringStatus } =
    useUpdateUserVolunteeringStatus();

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setStep(DialogSteps.details);
      onClose();
    }
  };

  const handleBack = () => {
    switch (step) {
      case DialogSteps.application:
        setStep(DialogSteps.details);
        break;
      case DialogSteps.logEffort:
        setStep(DialogSteps.details);
        break;
      default:
        handleClose();
        break;
    }
  };

  const handleStartApplying = () => {
    if (userVolunteeringStatus === 'none') {
      setStep(DialogSteps.application);
    }
  };

  const handleLogEffort = () => {
    if (userVolunteeringStatus === 'active') {
      setStep(DialogSteps.logEffort);
    }
  };

  const submitApplication = async (values) => {
    const payload = {
      skills: values.skillIds,
      opportunityId: opportunity.id,
      message: values.message,
    };

    const { errored } = await applyAsVolunteer(payload, opportunity);
    if (!errored) {
      setSuccessType('volunteer-application');
      setStep(DialogSteps.success);
      updateUserVolunteeringStatus({
        postId: post.id,
        status: 'pending',
      });
    }
  };

  const submitEffort = async (payload) => {
    const { data, errored } = await submitVolunteeringEffort(
      payload,
      opportunity,
    );
    if (!errored) {
      setRewardEarned(data.reward);
      setSuccessType('volunteering-effort');
      setStep(DialogSteps.success);
      updateUserVolunteeringStatus({
        postId: post.id,
        status: 'completed',
      });
    }
  };

  const getTitle = () => {
    switch (step) {
      case DialogSteps.application:
        return `Apply as volunteer for ${opportunity.name}`;
      case DialogSteps.logEffort:
        return `Log volunteering effort for ${opportunity.name}`;
      case DialogSteps.success:
        return '';
      default:
        return opportunity.name;
    }
  };

  const getMaxWidth = () => {
    switch (step) {
      case DialogSteps.application:
      case DialogSteps.logEffort:
        return 'md';
      default:
        return 'lg';
    }
  };

  if (open) {
    return (
      <Dialog
        maxWidth={getMaxWidth()}
        isOpen={open}
        onClose={handleClose}
        title={getTitle()}>
        <div className="flex w-full flex-col gap-4 overflow-hidden p-0 lg:p-0">
          {step === DialogSteps.details && (
            <VolunteeringDetails
              opportunity={opportunity}
              userVolunteeringStatus={userVolunteeringStatus}
              onSubmit={handleStartApplying}
              onLogEffort={handleLogEffort}
              nonProfit={nonProfit}
            />
          )}
          {step === DialogSteps.application && (
            <VolunteeringApplicationForm
              opportunity={opportunity}
              onSubmit={submitApplication}
              onClose={handleClose}
              onBack={handleBack}
              fullScreen={fullScreen}
            />
          )}
          {/* {step === DialogSteps.success && (
            <div className="flex flex-col gap-2">
              <div>
                <ActivitySuccess
                  header="Thank you!"
                  subheader={userProfile.fullName}
                  reward={rewardEarned}
                />
              </div>
              <div>
                <Stack direction="row" justifyContent="end">
                  <StyledContainedButton type="button" onClick={handleClose}>
                    Close
                  </StyledContainedButton>
                </Stack>
              </div>
            </div>
          )} */}
          {step === DialogSteps.logEffort && (
            <VolunteeringEffortForm
              opportunity={opportunity}
              onSubmit={submitEffort}
              onClose={handleClose}
              onBack={handleBack}
              fullScreen={fullScreen}
            />
          )}
          {step === DialogSteps.success && (
            <ActivitySuccessDialog
              user={profile}
              onClose={() => handleClose()}
              reward={rewardEarned}
              isPost={successType}
            />
          )}
        </div>
      </Dialog>
    );
  }
  return null;
}

export default VolunteeringDetailsDialog;
